import { ETwoFactorStatus } from '../../types/authentication';
import { AUTHENTICATION_TWO_FACTOR_TYPE } from '../../constants/action_types';
import { sendTwoFactorCode as sendTwoFactorCodeApi, sendTwoFactorWithEmailCode as sendTwoFactorWithEmailCodeApi } from '../../api/twoFactor';
export function sendTwoFactorCode(phone) {
  return function (dispatch, getState, context) {
    dispatch({
      status: ETwoFactorStatus.Loading,
      type: AUTHENTICATION_TWO_FACTOR_TYPE
    });

    var _getState = getState(),
        login = _getState.login;

    return sendTwoFactorCodeApi(context.httpApi, context.subdomain, {
      login: login,
      phone: phone
    }).then(function (response) {
      if (response.statusCode === 204) {
        dispatch({
          status: ETwoFactorStatus.Succeed,
          type: AUTHENTICATION_TWO_FACTOR_TYPE
        });
        return;
      }

      dispatch({
        status: ETwoFactorStatus.Failed,
        type: AUTHENTICATION_TWO_FACTOR_TYPE,
        error: response.response.message
      });
    }).catch(function (error) {
      context.logger.error(error);
      dispatch({
        status: ETwoFactorStatus.Failed,
        type: AUTHENTICATION_TWO_FACTOR_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}
export function sendTwoFactorWithEmailCode() {
  return function (dispatch, getState, context) {
    dispatch({
      status: ETwoFactorStatus.Loading,
      type: AUTHENTICATION_TWO_FACTOR_TYPE
    });

    var _getState2 = getState(),
        login = _getState2.login,
        password = _getState2.authentication.password;

    return sendTwoFactorWithEmailCodeApi(context.httpApi, context.subdomain, {
      login: login,
      password: password
    }).then(function (response) {
      if (response.statusCode === 204) {
        dispatch({
          status: ETwoFactorStatus.Succeed,
          type: AUTHENTICATION_TWO_FACTOR_TYPE
        });
        return;
      }

      dispatch({
        status: ETwoFactorStatus.Failed,
        type: AUTHENTICATION_TWO_FACTOR_TYPE,
        error: response.response.message
      });
    }).catch(function (error) {
      context.logger.error(error);
      dispatch({
        status: ETwoFactorStatus.Failed,
        type: AUTHENTICATION_TWO_FACTOR_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}